/**
 * イベントの時系列状態
 *
 * DateTimeType（fixed/poll/undecided）とは直交する、現在時刻に対する相対的な状態。
 * - past: 終了済み（確定: 開始・終了後 / 候補日: 最初の候補が過去）
 * - ongoing: 開催中（確定のみ。候補日や未定は対象外）
 * - future: 未来（確定: 開始前 / 候補日: 最初の候補が未来）
 * - undecided: 日時未定、または日時情報が欠落している場合
 */
export type EventTemporalState = 'past' | 'ongoing' | 'future' | 'undecided';

export const EVENT_TEMPORAL_STATE = {
  PAST: 'past',
  ONGOING: 'ongoing',
  FUTURE: 'future',
  UNDECIDED: 'undecided',
} as const satisfies Record<string, EventTemporalState>;
